document.addEventListener("DOMContentLoaded", function () {
    const calculateButton = document.getElementById("calculateButton");
    const calculateButtonKP = document.getElementById("calculateButtonKP");
    const calculateButtonKPu = document.getElementById("calculateButtonKPu");
  
    const totalPriceElement = document.getElementById("totalPrice");
    const calculatorForm = document.getElementById("calculator-form");
    const infoText = document.getElementById("infoText");
  
    const pintaAlaOsa = document.getElementById("pinta-ala");
    const kerroksetOsa = document.getElementById("kerrokset");
    const onkoMaalattuOsa = document.getElementById("onkoMaalattu");
    const kuntoOsa = document.getElementById("kunto");

    const pohjapintaAlaOsa = document.getElementById("pohja-pinta-ala");
    const jyrkkyysOsa = document.getElementById("jyrkkyys");
    const onkoTiiliaOsa = document.getElementById("onkoTiilia");

    const pohjapintaAla2Osa = document.getElementById("pohja-pinta-ala2");
    const jyrkkyys2Osa = document.getElementById("jyrkkyys2");
    const onkoTiilia2Osa = document.getElementById("onkoTiilia2");
  
    const yvOsa = document.getElementById("yhteenveto");
    const returnButton = document.querySelector(".return-button");
    const talonMaalaus = document.getElementById("talon-maalaus");
    const katonPinnoitus = document.getElementById("katon-pinnoitus");
    const katonPuhdistus = document.getElementById("katon-puhdistus");
    const taloTab = document.getElementById("talo-tab");
    const pinnTab = document.getElementById("pinn-tab");
    const puhdTab = document.getElementById("puhd-tab");
  
    const inputFields = document.querySelectorAll('input[type="number"]');
    inputFields.forEach((inputField) => {
      inputField.addEventListener('input', function() {
        if (parseFloat(this.value) < 0) {
          this.value = 0;
        }
      });
    });

    document.getElementById('tiiltenMaara2').addEventListener('input', function () {
        var onTiilia2 = document.getElementById('onTiilia2');
        onTiilia2.checked = this.value !== '';
    });

    document.getElementById('tiiltenMaara').addEventListener('input', function () {
        var onTiilia = document.getElementById('onTiilia');
        onTiilia.checked = this.value !== '';
    });

    calculateButton.addEventListener("click", function () {
      var pintaAla = document.getElementById("pintaAla").value;
      if (!pintaAla || isNaN(pintaAla) || pintaAla <= 0) {
        pintaAlaOsa.style.border = "1px dashed red";
        kerroksetOsa.style.border = "none";
        onkoMaalattuOsa.style.border = "none";
        kuntoOsa.style.border = "none";
        return;
      }
  
      // Validate if one of the Kerrokset options is checked
      var kerroksetOptions = document.getElementsByName("Kerrokset");
      var kerrosChecked = false;
      for (var i = 0; i < kerroksetOptions.length; i++) {
        if (kerroksetOptions[i].checked) {
          kerrosChecked = true;
          break;
        }
      }
      if (!kerrosChecked) {
        kerroksetOsa.style.border = "1px dashed red";
        pintaAlaOsa.style.border = "none";
        onkoMaalattuOsa.style.border = "none";
        kuntoOsa.style.border = "none";
        return;
      }
  
      // Validate if onkoMaalattu option is checked
      var onkoMaalattuOptions = document.getElementsByName("onkoMaalattu");
      var onkoMaalattuChecked = false;
      for (var i = 0; i < onkoMaalattuOptions.length; i++) {
        if (onkoMaalattuOptions[i].checked) {
          onkoMaalattuChecked = true;
          break;
        }
      }
      if (!onkoMaalattuChecked) {
        onkoMaalattuOsa.style.border = "1px dashed red";
        pintaAlaOsa.style.border = "none";
        kerroksetOsa.style.border = "none";
        kuntoOsa.style.border = "none";
        return;
      }
  
      // Validate if Kunto option is checked
      var kuntoOptions = document.getElementsByName("Kunto");
      var kuntoChecked = false;
      for (var i = 0; i < kuntoOptions.length; i++) {
        if (kuntoOptions[i].checked) {
          kuntoChecked = true;
          break;
        }
      }
      if (!kuntoChecked) {
        kuntoOsa.style.border = "1px dashed red";
        pintaAlaOsa.style.border = "none";
        kerroksetOsa.style.border = "none";
        onkoMaalattuOsa.style.border = "none";
        return;
      }
      let totalPricefloor = 0;
      let totalPriceceiling = 0;

      pintaAlaOsa.style.border = "none";
      kerroksetOsa.style.border = "none";
      onkoMaalattuOsa.style.border = "none";
      kuntoOsa.style.border = "none";
      
      const pintaAlainput = parseFloat(document.getElementById("pintaAla").value);
      totalPricefloor += pintaAlainput * 18.33;
      totalPriceceiling += pintaAlainput * 21.87;

      const kerrosRadio = parseFloat(document.querySelector('input[name="Kerrokset"]:checked').value);
      totalPricefloor *= kerrosRadio;
      totalPriceceiling *= kerrosRadio;

      const onkoMaalattuRadio = parseFloat(document.querySelector('input[name="onkoMaalattu"]:checked').value);
      totalPricefloor *= onkoMaalattuRadio;
      totalPriceceiling *= onkoMaalattuRadio;

      const kuntoRadio = parseFloat(document.querySelector('input[name="Kunto"]:checked').value);
      totalPricefloor *= kuntoRadio;
      totalPriceceiling *= kuntoRadio;
      
      let kuntoTeksti;
      if (kuntoRadio === 1) {
        kuntoTeksti = "Ei hilseile";
      } else if (kuntoRadio === 1.56) {
        kuntoTeksti = "Hilseilee hieman";
      } else {
        kuntoTeksti = "Hilseilee paljon";
      }

      let kerrosTeksti;
      if (kerrosRadio === 1.37) {
        kerrosTeksti = "1";
      } else if (kerrosRadio === 1.75) {
        kerrosTeksti = "1,5";
      } else {
        kerrosTeksti = "2";
      }
      
      const yvValinnat = document.querySelector(".valinnat");

      yvValinnat.innerHTML = `Pohjapinta-ala: ${pintaAlainput}m&sup2<br>Kerrokset: ${kerrosTeksti}<br>Kunto: ${kuntoTeksti}`;
      totalPriceElement.textContent = `Hinta-arvio: ${Math.round(totalPricefloor)}-${Math.round(totalPriceceiling)}€`;

      talonMaalaus.style.display = "none";
      yvOsa.style.display = "block";
      totalPriceElement.style.display = "block";
      infoText.style.display = "block";
      returnButton.style.display = "block";
      
      returnButton.addEventListener("click", function () {
        katonPuhdistus.style.display = "none";
        talonMaalaus.style.display = "block";
        katonPinnoitus.style.display = "none";
        yvOsa.style.display = "none";
        totalPriceElement.style.display = "none";
        infoText.style.display = "none";
        returnButton.style.display = "none";
      });
    });

    calculateButtonKP.addEventListener("click", function () {
      var pohjapintaAla = document.getElementById("pohja-pintaAla").value;
      if (!pohjapintaAla || isNaN(pohjapintaAla) || pohjapintaAla <= 0) {
        pohjapintaAlaOsa.style.border = "1px dashed red";
        jyrkkyysOsa.style.border = "none";
        onkoTiiliaOsa.style.border = "none";
        return;
      }
  
      var jyrkkyysOptions = document.getElementsByName("jyrkkyys");
      var jyrkkyysChecked = false;
      for (var i = 0; i < jyrkkyysOptions.length; i++) {
        if (jyrkkyysOptions[i].checked) {
          jyrkkyysChecked = true;
          break;
        }
      }
      if (!jyrkkyysChecked) {
        jyrkkyysOsa.style.border = "1px dashed red";
        pohjapintaAlaOsa.style.border = "none";
        onkoTiiliaOsa.style.border = "none";
        return;
      }
  
      var onkoTiiliaOptions = document.getElementsByName("onkoTiilia");
      var onkoTiiliaChecked = false;
      for (var i = 0; i < onkoTiiliaOptions.length; i++) {
        if (onkoTiiliaOptions[i].checked) {
          onkoTiiliaChecked = true;
          break;
        }
      }
      if (!onkoTiiliaChecked) {
        onkoTiiliaOsa.style.border = "1px dashed red";
        pohjapintaAlaOsa.style.border = "none";
        jyrkkyysOsa.style.border = "none";
        return;
      }

      var tiiliKPL = document.getElementById("tiiltenMaara").value;
      const onkoTiiliaRadio = parseFloat(document.querySelector('input[name="onkoTiilia"]:checked').value);
      if ((!tiiliKPL || isNaN(tiiliKPL) || tiiliKPL <= 0) && (onkoTiiliaRadio === 40)) {
        onkoTiiliaOsa.style.border = "1px dashed red";
        jyrkkyysOsa.style.border = "none";
        pohjapintaAlaOsa.style.border = "none";
        return;
      }

      
      let totalPricefloor = 0;
      let totalPriceceiling = 0;

      pohjapintaAlaOsa.style.border = "none";
      jyrkkyysOsa.style.border = "none";
      onkoTiiliaOsa.style.border = "none";
      
      const pohjapintaAlainput = parseFloat(document.getElementById("pohja-pintaAla").value);
      totalPricefloor += pohjapintaAlainput * 1.3;
      totalPriceceiling += pohjapintaAlainput * 1.3;

      const jyrkkyysRadio = parseFloat(document.querySelector('input[name="jyrkkyys"]:checked').value);
      if (jyrkkyysRadio === 1) {
        totalPricefloor *= 20.5;
        totalPriceceiling *= 25;
      } else if (jyrkkyysRadio === 2) {
        totalPricefloor *= 22.4;
        totalPriceceiling *= 28.6;
      }

      const tiiliKPLflt = parseFloat(document.getElementById("tiiltenMaara").value);
      if (onkoTiiliaRadio === 40) {
        totalPricefloor += 40 * parseFloat(tiiliKPLflt);
        totalPriceceiling += 40 * parseFloat(tiiliKPLflt);
      } else if (onkoTiiliaRadio === 100) {
        totalPricefloor += 100;
        totalPriceceiling += 100;
      }
      
      let jyrkkyysTeksti;
      if (jyrkkyysRadio === 1) {
        jyrkkyysTeksti = "Loiva";
      } else if (jyrkkyysRadio === 2) {
        jyrkkyysTeksti = "Jyrkkä";
      }

      let tiiliTeksti;
      if (onkoTiiliaRadio === 40) {
        tiiliTeksti = `Kyllä ${tiiliKPLflt}kpl`;
      } else if (onkoTiiliaRadio === 0) {
        tiiliTeksti = "Ei";
      } else {
        tiiliTeksti = "En tiedä";
      }
      
      const yvValinnat = document.querySelector(".valinnat");

      yvValinnat.innerHTML = `Pohjapinta-ala: ${pohjapintaAlainput}m&sup2<br>Jyrkkyys: ${jyrkkyysTeksti}<br>Tiiliä rikki: ${tiiliTeksti}`;
      totalPriceElement.textContent = `Hinta-arvio: ${Math.round(totalPricefloor)}-${Math.round(totalPriceceiling)}€`;

      katonPinnoitus.style.display = "none";
      yvOsa.style.display = "block";
      totalPriceElement.style.display = "block";
      infoText.style.display = "block";
      returnButton.style.display = "block";

      returnButton.addEventListener("click", function () {
        katonPuhdistus.style.display = "none";
        talonMaalaus.style.display = "none";
        katonPinnoitus.style.display = "block";
        yvOsa.style.display = "none";
        totalPriceElement.style.display = "none";
        infoText.style.display = "none";
        returnButton.style.display = "none";
      });
    });

    calculateButtonKPu.addEventListener("click", function () {
      var pohjapintaAla2 = document.getElementById("pohja-pintaAla2").value;
      if (!pohjapintaAla2 || isNaN(pohjapintaAla2) || pohjapintaAla2 <= 0) {
        pohjapintaAla2Osa.style.border = "1px dashed red";
        jyrkkyys2Osa.style.border = "none";
        onkoTiilia2Osa.style.border = "none";
        return;
      }
  
      var jyrkkyysOptions2 = document.getElementsByName("jyrkkyys2");
      var jyrkkyysChecked2 = false;
      for (var i = 0; i < jyrkkyysOptions2.length; i++) {
        if (jyrkkyysOptions2[i].checked) {
          jyrkkyysChecked2 = true;
          break;
        }
      }
      if (!jyrkkyysChecked2) {
        jyrkkyys2Osa.style.border = "1px dashed red";
        pohjapintaAla2Osa.style.border = "none";
        onkoTiilia2Osa.style.border = "none";
        return;
      }
  
      var onkoTiiliaOptions2 = document.getElementsByName("onkoTiilia2");
      var onkoTiiliaChecked2 = false;
      for (var i = 0; i < onkoTiiliaOptions2.length; i++) {
        if (onkoTiiliaOptions2[i].checked) {
          onkoTiiliaChecked2 = true;
          break;
        }
      }
      if (!onkoTiiliaChecked2) {
        onkoTiilia2Osa.style.border = "1px dashed red";
        pohjapintaAla2Osa.style.border = "none";
        jyrkkyys2Osa.style.border = "none";
        return;
      }

      var tiiliKPL2 = document.getElementById("tiiltenMaara2").value;
      const onkoTiiliaRadio2 = parseFloat(document.querySelector('input[name="onkoTiilia2"]:checked').value);
      if ((!tiiliKPL2 || isNaN(tiiliKPL2) || tiiliKPL2 <= 0) && (onkoTiiliaRadio2 === 40)) {
        onkoTiilia2Osa.style.border = "1px dashed red";
        jyrkkyys2Osa.style.border = "none";
        pohjapintaAla2Osa.style.border = "none";
        return;
      }

      
      let totalPricefloor = 0;
      let totalPriceceiling = 0;

      pohjapintaAla2Osa.style.border = "none";
      jyrkkyys2Osa.style.border = "none";
      onkoTiilia2Osa.style.border = "none";
      
      const pohjapintaAlainput2 = parseFloat(document.getElementById("pohja-pintaAla2").value);
      totalPricefloor += pohjapintaAlainput2 * 1.3;
      totalPriceceiling += pohjapintaAlainput2 * 1.3;

      const jyrkkyysRadio2 = parseFloat(document.querySelector('input[name="jyrkkyys2"]:checked').value);
      if (jyrkkyysRadio2 === 1) {
        totalPricefloor *= 5.7;
        totalPriceceiling *= 9.9;
      } else if (jyrkkyysRadio2 === 2) {
        totalPricefloor *= 8.4;
        totalPriceceiling *= 12.2;
      }

      const tiiliKPLflt2 = parseFloat(document.getElementById("tiiltenMaara2").value);
      if (onkoTiiliaRadio2 === 40) {
        totalPricefloor += 40 * parseFloat(tiiliKPLflt2);
        totalPriceceiling += 40 * parseFloat(tiiliKPLflt2);
      } else if (onkoTiiliaRadio2 === 100) {
        totalPricefloor += 100;
        totalPriceceiling += 100;
      }
      
      let jyrkkyysTeksti2;
      if (jyrkkyysRadio2 === 1) {
        jyrkkyysTeksti2 = "Loiva";
      } else if (jyrkkyysRadio2 === 2) {
        jyrkkyysTeksti2 = "Jyrkkä";
      }

      let tiiliTeksti2;
      if (onkoTiiliaRadio2 === 40) {
        tiiliTeksti2 = `Kyllä ${tiiliKPLflt2}kpl`;
      } else if (onkoTiiliaRadio2 === 0) {
        tiiliTeksti2 = "Ei";
      } else {
        tiiliTeksti2 = "En tiedä";
      }
      
      const yvValinnat = document.querySelector(".valinnat");

      yvValinnat.innerHTML = `Pohjapinta-ala: ${pohjapintaAlainput2}m&sup2<br>Jyrkkyys: ${jyrkkyysTeksti2}<br>Tiiliä rikki: ${tiiliTeksti2}`;
      totalPriceElement.textContent = `Hinta-arvio: ${Math.round(totalPricefloor)}-${Math.round(totalPriceceiling)}€`;

      katonPuhdistus.style.display = "none";
      yvOsa.style.display = "block";
      totalPriceElement.style.display = "block";
      infoText.style.display = "block";
      returnButton.style.display = "block";

      returnButton.addEventListener("click", function () {
        katonPuhdistus.style.display = "block";
        talonMaalaus.style.display = "none";
        katonPinnoitus.style.display = "none";
        yvOsa.style.display = "none";
        totalPriceElement.style.display = "none";
        infoText.style.display = "none";
        returnButton.style.display = "none";
      });
    });

    taloTab.addEventListener("click", function() {
      calculatorForm.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0625/0220/7668/files/valkoinen-pensseli.jpg?v=1705567979')";
      if (window.matchMedia("(max-width: 749px)").matches) {
        calculatorForm.style.backgroundSize = "150%";
      } else {
        calculatorForm.style.backgroundSize = "100%";
      }
      talonMaalaus.style.display = "block";
      taloTab.style.zIndex = "1";
      taloTab.style.backgroundColor = "#E2E5EE";
      pinnTab.style.color = "#000";
      pinnTab.style.zIndex = "0";
      pinnTab.style.backgroundColor = "#fff";
      puhdTab.style.color = "#000";
      puhdTab.style.zIndex = "0";
      puhdTab.style.background = "none";
      katonPinnoitus.style.display = "none";
      katonPuhdistus.style.display = "none";
      yvOsa.style.display = "none";
      totalPriceElement.style.display = "none";
      infoText.style.display = "none";
      returnButton.style.display = "none";
    });

    pinnTab.addEventListener("click", function() {
      calculatorForm.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0625/0220/7668/files/tiilikatto.jpg?v=1705560697')";
      if (window.matchMedia("(max-width: 749px)").matches) {
        calculatorForm.style.backgroundSize = "350%";
      } else {
        calculatorForm.style.backgroundSize = "250%";
      }
      talonMaalaus.style.display = "none";
      pinnTab.style.color = "#fff";
      pinnTab.style.backgroundColor = "#075DAA";
      pinnTab.style.zIndex = "1";
      taloTab.style.zIndex = "0";
      taloTab.style.backgroundColor = "#fff";
      puhdTab.style.color = "#000";
      puhdTab.style.zIndex = "0";
      puhdTab.style.background = "none";
      katonPinnoitus.style.display = "block";
      katonPuhdistus.style.display = "none";
      yvOsa.style.display = "none";
      totalPriceElement.style.display = "none";
      infoText.style.display = "none";
      returnButton.style.display = "none";
    });

    puhdTab.addEventListener("click", function() {
      calculatorForm.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0625/0220/7668/files/katonpuhd.jpg?v=1705927054')";
      if (window.matchMedia("(max-width: 749px)").matches) {
        calculatorForm.style.backgroundSize = "150%";
      } else {
        calculatorForm.style.backgroundSize = "100%";
      }
      talonMaalaus.style.display = "none";
      puhdTab.style.zIndex = "1";
      puhdTab.style.background = "linear-gradient(90deg, rgba(252,213,138,1) 0%, rgba(242,200,140,1) 15%, rgba(255,254,146,1) 32%)";
      pinnTab.style.color = "#000";
      pinnTab.style.zIndex = "0";
      pinnTab.style.backgroundColor = "#fff";
      taloTab.style.zIndex = "0";
      taloTab.style.backgroundColor = "#fff";
      katonPinnoitus.style.display = "none";
      katonPuhdistus.style.display = "block";
      yvOsa.style.display = "none";
      totalPriceElement.style.display = "none";
      infoText.style.display = "none";
      returnButton.style.display = "none";
    });
  });
 